const KAKAO_POSTCODE_SCRIPT_URL =
  process.env.REACT_APP_KAKAO_POSTCODE_SCRIPT_URL ||
  'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

let kakaoPostcodeScriptLoadingPromise = null;

export async function loadKakaoPostcodeScript() {
  if (typeof window === 'undefined') {
    throw new Error('브라우저 환경에서만 주소 검색을 사용할 수 있습니다.');
  }

  if (window.daum?.Postcode) {
    return window.daum.Postcode;
  }

  if (kakaoPostcodeScriptLoadingPromise) {
    return kakaoPostcodeScriptLoadingPromise;
  }

  kakaoPostcodeScriptLoadingPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector('script[data-kakao-postcode-script="true"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        if (window.daum?.Postcode) {
          resolve(window.daum.Postcode);
          return;
        }
        reject(new Error('카카오 주소 검색 스크립트 초기화에 실패했습니다.'));
      });
      existingScript.addEventListener('error', () => {
        reject(new Error('카카오 주소 검색 스크립트를 불러오지 못했습니다.'));
      });
      return;
    }

    const script = document.createElement('script');
    script.src = KAKAO_POSTCODE_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.dataset.kakaoPostcodeScript = 'true';
    script.onload = () => {
      if (window.daum?.Postcode) {
        resolve(window.daum.Postcode);
        return;
      }
      reject(new Error('카카오 주소 검색 스크립트 초기화에 실패했습니다.'));
    };
    script.onerror = () => {
      reject(new Error('카카오 주소 검색 스크립트를 불러오지 못했습니다.'));
    };
    document.head.appendChild(script);
  }).catch((error) => {
    kakaoPostcodeScriptLoadingPromise = null;
    throw error;
  });

  return kakaoPostcodeScriptLoadingPromise;
}
